import { memo, useCallback } from 'react';
import { Box, Image, Text } from '@betty/moonlight';
import { NoPromoProps } from './NoPromo.types';
import PromoContainer from '../PromoContainer/PromoContainer';

function NoPromo({ selected, onPress }: NoPromoProps) {
  const handlePress = useCallback(() => onPress(), [onPress]);

  return (
    <PromoContainer selected={selected} onPress={handlePress}>
      <Box width={80} height={80} centerContent>
        <Image name="wallet.noPromo" width={64} height={64} />
      </Box>
      <Text
        flex={1}
        variant="body-s-semi"
        locNS="wallet"
        locKey="depositNoPromo"
        color="darkSurfacePrimary"
      />
    </PromoContainer>
  );
}

export default memo(NoPromo);
